import React from 'react';
import SiteHtmlPage from '../components/siteContent/SiteHtmlPage';

const CodeOfConductPage = () => <SiteHtmlPage slug="code-of-conduct" />;

export default CodeOfConductPage;
